import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AgencyConfigState } from './agencyConfig.reducer';

export const agencyConfigStateSelector =
  createFeatureSelector<Readonly<AgencyConfigState>>('agencyConfig');

export const agencyConfigSelector = createSelector(
  agencyConfigStateSelector,
  (state) => {
    return state.agencyConfig;
  }
);
export const isSecondKeySelector = createSelector(
  agencyConfigStateSelector,
  (state) => {
    return state.agencyConfig?.isSeconKey;
  }
);
export const agencyLoader = createSelector(
  agencyConfigStateSelector,
  (state) => {
    return state.status;
  }
);
